import { Map } from 'immutable';

export const MAX_BACKOFF_MS = 120000;
export const BASE_BACKOFF_MS = 2000;

// Max priority according to rfc2782
const MAX_PRIORITY = 65535;

export const FALLBACK_KMS_SERVER = {
    publicUrl: 'kms1.telavox.se',
    websocketPort: 443,
};

/**
 * Return a random server based, distributed for weight.
 *
 * This function has tests that has been commented out, as the result from this
 * function is random. If you're changing this function, please run the tests
 * during development.
 *
 * @param {List[OperatorServerDTO]} servers - A list of operator servers
 */
export const getRandomServer = (servers) => {
    const totalWeight = servers.reduce(
        (acc, server) => acc + server.get('weight'),
        0,
    );
    const chosenWeight = Math.random() * totalWeight;
    let accumulatedWeight = 0;
    return servers.find((server) => {
        accumulatedWeight += server.get('weight');
        return chosenWeight < accumulatedWeight;
    });
};

/**
 * This formula describes how to calculate the backoff time for a "Exponential backoff with
 * full jitter" algorithm. Read more at
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
 *
 * @param numberOfAttempts  The number of attempts we've tried to connect
 * @returns {number} A new time in ms that we should wait before trying to connect again.
 */
export const calculateBackoffTime = (numberOfAttempts = 0) => {
    const upperLimit = Math.min(
        MAX_BACKOFF_MS,
        BASE_BACKOFF_MS * Math.pow(2, numberOfAttempts),
    );
    return Math.random() * upperLimit;
};

export const parseSipSockets = (sipServers) => {
    if (!sipServers) {
        return Map();
    }
    return sipServers.map((item) => {
        let target = item.target;
        // Since DNS records commonly have a trailing dot, we need to remove it for JsSIP to be happy
        if (target[target.length - 1] === '.') {
            target = target.substring(0, target.length - 1);
        }
        const port = item.port;
        // Priority on an SRV record is lowest first, while weight in JsSIP is similar but highest first
        const weight = MAX_PRIORITY - item.priority;
        const socketUrl = 'wss://' + target + ':' + port;
        return {
            socketUrl,
            weight,
        };
    });
};
